module.exports = __webpack_public_path__ + "img/logout1.e2a93488.svg";